module.exports = __webpack_public_path__ + "img/gestao.de4d7fc9.png";